import styled from "styled-components";

export const Container = styled.div.attrs({
    className: "sub-page"
})`
    width: 100%;
    height: 100vh;
    background-color: ${props => props.theme.colors.background};
    max-width: 960px;
    flex-direction: column;

    @media (min-width: 767px) {
        width: 80%;
    }

    @media (min-width: 1200px) {
        width: 65%;
    }
`;

export const Content = styled.div`
    width: 100%;
    height: calc(100vh - 72px);
    padding: 15px;
    overflow: none;
    overflow-y: auto;
    padding-bottom: 50px;
`;